exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".time-label{\n    font-weight: bold;\n    margin-right: 10px;\n}\n\n.search{\n   margin: 24px 0 0 0;\n}", "", {"version":3,"sources":["/home/dev/bitool-new/client/app/main/reports/doctor-division-report/doctor-division.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,mBAAmB;CACtB;;AAED;GACG,mBAAmB;CACrB","file":"doctor-division.css","sourcesContent":[".time-label{\n    font-weight: bold;\n    margin-right: 10px;\n}\n\n.search{\n   margin: 24px 0 0 0;\n}"],"sourceRoot":""}]);

// exports
